import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {ApxReportMenu} from './../Enums/Enums';

class MenuReports extends React.Component {
  state = {
    value: 1,
  };

  handleChange = (event, value) => {
    this.setState({ value });
    this.props.data.Main.ReportChangeCallback(value);
  };

  render() {
    const { value } = this.state;
    return (
        <div>
            <Tabs value={value} onChange={this.handleChange.bind(this)}>
              <Tab label="FINANCE"   value={ApxReportMenu.Finance} />
              <Tab label="SUPPORT"  value={ApxReportMenu.Support} />
              <Tab label="CLIENT FACING"  value={ApxReportMenu.ClientFacing} />}
            </Tabs>
        </div>
    );
  }
}

export default MenuReports;